import React from 'react';

const ITEMS = [
  { label: 'NEA Approved Real-Time Noise Monitoring Provider' },
];

const Credibility: React.FC = () => (
  <div className="cv-cred">
    <div className="cv-container cv-cred__inner">
      <span className="cv-cred__label">Recognised by</span>
      <div className="cv-cred__list">
        {ITEMS.map((item) => (
          <span className="cv-cred__badge" key={item.label}>{item.label}</span>
        ))}
      </div>
    </div>
  </div>
);

export default Credibility;
